import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { Button, Card, Select, Input, message, Checkbox, Radio, InputNumber } from 'antd';
import { mutations, queries } from '../../graphql/graphql';
import Upload from '../Upload';
import { v4 as uuidv4 } from 'uuid';
// import { SelectTemplate } from '../Templates/Select';
// import AnswerForSpecifications from '../Specifications/AnswerForSpecifications';
import AvailableArea from './AvailableArea';

import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import _s from './index.less';
import SVGView from './SVGView';
import { FindConfigurator } from './FindConfigurator';
import { FindPhotos } from './FindPhotos';
import { FluxExterior } from './FluxExterior';

const { Option } = Select;

const PlanEdit = props => {
  const { params } = props.match;

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [url, setUrl] = useState('');
  const [contractorId, setContractorId] = useState('');
  const [image, setImage] = useState({});
  const [specifications, setSpecifications] = useState([]);
  // const [templateId, setTemplateId] = useState('');
  const [photos, setPhotos] = useState([]);
  const [isHidden, setIsHidden] = useState(false);
  const [decorId, setDecorId] = useState('');
  const [planId, setPlanId] = useState('');
  const [planSVG, setPlanSVG] = useState('');
  const [hasARModel, setHasARModel] = useState(false);
  const [isModular, setIsModular] = useState(false);
  const [isManufactured, setIsManufactured] = useState(false);
  const [preApproved, setPreApproved] = useState(false);
  const [arModelLink, setARModelLink] = useState('');
  const [planCost, setPlanCost] = useState(1500);
  const [fixPrice, setFixPrice] = useState(null);
  const [totalArea, setTotalArea] = useState(0);
  const [outerArea, setOuterArea] = useState(0);
  const [bathroom, setBathroom] = useState([]);
  const [kitchen, setKitchen] = useState([]);
  const [bedroom, setBedroom] = useState([]);
  const [width, setWidth] = useState(0);
  const [length, setLength] = useState(0);
  const [type, setType] = useState('house');
  const [sourcePlan, setSourcePlan] = useState('');
  const [available, setAvailable] = useState({});

  const [contractor, setContractor] = useState({});
  const [isSubmitting] = useState(false);

  const contractorsResponse = useQuery(queries.CONTRACTORS);
  const contractors = (contractorsResponse.data && contractorsResponse.data.contractors) || [];

  const { data = {} } = useQuery(queries.PLAN, { variables: { id: params.id } });

  const setContractorById = id => {
    const Idx = contractors.findIndex(el => el.id === id && el);
    if (Idx > -1) setContractor(contractors[Idx]);
  };

  useEffect(() => {
    if (data && data.plan) {
      const {
        contractorId,
        title,
        description,
        url,
        // templateId,
        specifications,
        photos = [],
        image,
        meta,
        decorId,
        isHidden,
        planSVG,
        planId,
        hasARModel,
        arModelLink,
        planCost,
        isModular,
        isManufactured,
        preApproved,
        fixPrice,
        sourcePlan,
        available
      } = data.plan;

      setImage({ uid: uuidv4(), url: image, status: 'done' });
      setPhotos(
        photos.map(image => ({
          uid: uuidv4(),
          url: image.original,
          status: 'done',
          selected: image.isPublish,
          isPrimary: !!image.isPrimary
        }))
      );
      setContractorId(contractorId);
      setTitle(title);
      setDescription(description);
      setUrl(url);
      if (contractors.length) {
        setContractorById(contractorId);
      }
      // if (templateId) setTemplateId(templateId);
      if (specifications) setSpecifications(specifications);
      if (decorId) setDecorId(decorId);
      if (isHidden) setIsHidden(isHidden);
      if (meta) {
        setOuterArea(meta.outerArea || 0);
        setTotalArea(meta.totalArea || 0);
        setBathroom(meta.bathroom || []);
        setKitchen(meta.kitchen || []);
        setBedroom(meta.bedroom || []);
        setWidth(meta.width || 0);
        setLength(meta.length || 0);
        setType(meta.type);
      }
      if (planSVG) setPlanSVG(planSVG);
      if (planId) setPlanId(planId);
      if (hasARModel) setHasARModel(hasARModel);
      if (arModelLink) setARModelLink(arModelLink);
      if (planCost) setPlanCost(planCost);
      if (fixPrice) setFixPrice(fixPrice);
      if (isModular) setIsModular(isModular);
      if (isManufactured) setIsManufactured(isManufactured);
      if (preApproved) setPreApproved(preApproved);
      if (sourcePlan) setSourcePlan(sourcePlan);
      if (available) setAvailable(available);
    }
  }, [data]);

  const selectContractor = id => {
    setContractorById(id);
    setContractorId(id);
  };

  const options = contractors.map(item => (
    <Option key={item.id} value={item.id}>
      {item.name}
    </Option>
  ));

  const [PLAN_UPDATE] = useMutation(mutations.PLAN_UPDATE);

  const savePlan = () => {
    const data = {
      id: params.id,
      contractorId,
      title,
      description,
      url,
      image: image.url,
      // templateId,
      specifications,
      photos: photos.map(p => ({
        original: p.url,
        isPublish: p.selected,
        isPrimary: !!p.isPrimary
      })),
      isHidden,
      decorId,
      meta: {
        totalArea,
        outerArea,
        bathroomCount: bathroom.length,
        bathroom,
        kitchenCount: kitchen.length,
        kitchen,
        bedroomCount: bedroom.length,
        bedroom,
        width,
        length,
        type
      },
      planSVG,
      planId,
      hasARModel,
      arModelLink,
      planCost: Number(planCost),
      isModular,
      isManufactured,
      preApproved,
      fixPrice: Number(fixPrice),
      sourcePlan,
      available
    };

    PLAN_UPDATE({ variables: data }).then(
      res => {
        message.success('Plan updated!');
        const { data } = res;
        const { planUpdate } = data;
        props.history.push(`/plan/${planUpdate.id}`);
      },
      err => {
        console.log(err);
        message.error('Error. Check if all fields are filled.');
      }
    );
  };

  const onChange = (e, setState) => {
    const { value } = e.target;
    setState(value);
  };

  const onChangeImage = item => {
    if (Array.isArray(item) && item.length > 0) {
      setImage(item[0]);
    }
  };

  const additem = (state, setState) => {
    const copy = [].concat(state);
    copy.push({ area: 0 });
    setState(copy);
  };

  const removeItem = (state, setState, index) => {
    const copy = [].concat(state);
    copy.splice(index, 1);
    setState(copy);
  };

  const onChangeArray = (state, setState, index, value) => {
    const copy = [].concat(state);
    copy[index] = value;
    setState(copy);
  };

  const listNumbers = (array, setState) => {
    return (
      <>
        {array.map((item, index) => (
          <div key={`listnumbers-${index}`}>
            <InputNumber
              value={item.area}
              onChange={value => onChangeArray(array, setState, index, { area: value })}
              min={0}
            />
            <Button
              type="dashed"
              onClick={() => removeItem(array, setState, index)}
              icon={<MinusCircleOutlined />}
            >
              remove
            </Button>
            <br />
          </div>
        ))}
        <br />
        <Button type="dashed" onClick={() => additem(array, setState)} icon={<PlusOutlined />}>
          add
        </Button>
      </>
    );
  };

  return (
    <div
      style={{
        display: 'block',
        width: '100vw',
        padding: 0,
        background: '#ffffff'
      }}
    >
      <div className={_s.answerBlock}>
        <Select value={contractorId} style={{ width: '100%' }} onChange={selectContractor}>
          {options}
        </Select>
      </div>
      {contractor && contractor.id && (
        <div className={_s.answerBlock}>
          <Card>
            <Card.Meta title={contractor.name} description={contractor.ceo} />
          </Card>
        </div>
      )}
      <div className={_s.answerBlock}>
        <Input
          name="title"
          placeholder="Title"
          onChange={e => onChange(e, setTitle)}
          value={title}
        />
      </div>
      <div className={_s.answerBlock}>
        <Input.TextArea
          name="description"
          placeholder="Description"
          onChange={e => onChange(e, setDescription)}
          value={description}
        />
      </div>
      <div className={_s.answerBlock}>
        <Input placeholder="model url" name="url" onChange={e => onChange(e, setUrl)} value={url} />
      </div>
      <div className={_s.answerBlock}>
        <FindConfigurator decorId={decorId} id={params.id} setUrl={setUrl} url={url} />
      </div>
      <div className={_s.answerBlock}>
        <Upload
          onChange={onChangeImage}
          items={image && image.uid ? [image] : []}
          placeholder="Upload logo"
          single={true}
          hasPublish={false}
        />
      </div>
      <div className={_s.answerBlock}>
        <Upload
          name="photos"
          onChange={setPhotos}
          items={photos}
          aspect={1.3}
          placeholder="Upload photos"
          crop={true}
          onSelect={setImage}
        />
      </div>
      <div className={_s.answerBlock}>
        <FindPhotos decorId={decorId} id={params.id} setPhotos={setPhotos} photos={photos} />
      </div>
      <div className={_s.answerBlock}>
        <FluxExterior
          planId={params.id}
          decorId={decorId}
          id={params.id}
          setPhotos={setPhotos}
          photos={photos}
        />
      </div>
      <div className={_s.answerBlock}>
        <Checkbox checked={isHidden} onChange={e => setIsHidden(e.target.checked)}>
          Hide
        </Checkbox>
      </div>
      <div className={_s.answerBlock}>
        <Input
          name="decorId"
          placeholder="Decor ID"
          onChange={e => onChange(e, setDecorId)}
          value={decorId}
        />
      </div>
      <div className={_s.answerBlock}>
        <Input
          name="planId"
          placeholder="Plan ID"
          onChange={e => onChange(e, setPlanId)}
          value={planId}
        />
      </div>
      <div className={_s.answerBlock}>
        <Checkbox checked={hasARModel} onChange={e => setHasARModel(e.target.checked)}>
          has AR model
        </Checkbox>
      </div>
      <div className={_s.answerBlock}>
        <span>Link to ar model</span>
        <Input
          name="arModelLink"
          placeholder="https://....."
          onChange={e => onChange(e, setARModelLink)}
          value={arModelLink}
        />
      </div>
      <div className={_s.answerBlock}>
        <span>Plan cost</span>
        <Input
          type="number"
          min={0}
          step={1}
          name="planCost"
          placeholder="1500"
          onChange={e => onChange(e, setPlanCost)}
          value={planCost}
        />
      </div>
      <div className={_s.answerBlock}>
        <span>Fix Price</span>
        <Input
          type="number"
          min={0}
          step={1}
          name="fixPrice"
          placeholder="100000"
          onChange={e => onChange(e, setFixPrice)}
          value={fixPrice}
        />
      </div>
      <div className={_s.answerBlock}>
        <Checkbox checked={isModular} onChange={e => setIsModular(e.target.checked)}>
          Modular
        </Checkbox>
      </div>
      <div className={_s.answerBlock}>
        <Checkbox checked={isManufactured} onChange={e => setIsManufactured(e.target.checked)}>
          Manufactured
        </Checkbox>
      </div>
      <div className={_s.answerBlock}>
        <Checkbox checked={preApproved} onChange={e => setPreApproved(e.target.checked)}>
          Pre-approved
        </Checkbox>
      </div>
      <div className={_s.answerBlock}>
        <span>Source plan</span>
        <Input
          name="sourcePlan"
          placeholder="https://....."
          onChange={e => onChange(e, setSourcePlan)}
          value={sourcePlan}
        />
      </div>
      <AvailableArea available={available} setAvailable={setAvailable} />
      <div
        className={_s.answerBlock}
        style={{ border: 'solid 2px', borderRadius: '2px', borderColor: 'lightgray' }}
      >
        <div className={_s.answerBlock}>
          <div>SVG</div>
          <SVGView planSVG={planSVG} planId={planId} />
        </div>
        <div className={_s.answerBlock}>
          <div>Exterior Area</div>
          <InputNumber
            name="outerArea"
            placeholder="Exterior Area"
            onChange={setOuterArea}
            value={outerArea}
            min={0}
          />
          <div>Total Area</div>
          <InputNumber
            name="totalArea"
            placeholder="Total Area"
            onChange={setTotalArea}
            value={totalArea}
            min={0}
          />
        </div>
        <div className={_s.answerBlock}>
          <div>Bathroom count: {bathroom.length}</div>
          <div>Bathrooms area</div>
          {listNumbers(bathroom, setBathroom)}
        </div>
        <div className={_s.answerBlock}>
          <div>Kitchen count: {kitchen.length}</div>
          <div>Kitchen area</div>
          {listNumbers(kitchen, setKitchen)}
        </div>
        <div className={_s.answerBlock}>
          <div>Bedroom count: {bedroom.length}</div>
          <div>Bedroom area</div>
          {listNumbers(bedroom, setBedroom)}
        </div>
        <div className={_s.answerBlock}>
          <div>Width</div>
          <InputNumber name="width" placeholder="Width" onChange={setWidth} value={width} min={0} />
        </div>
        <div className={_s.answerBlock}>
          <div>Length</div>
          <InputNumber
            name="length"
            placeholder="Length"
            onChange={setLength}
            value={length}
            min={0}
          />
        </div>
        <div className={_s.answerBlock}>
          <div>Type</div>
          <Radio.Group onChange={e => setType(e.target.value)} value={type}>
            <Radio value={'shed'}>Shed</Radio>
            <Radio value={'house'}>House</Radio>
          </Radio.Group>
        </div>
      </div>
      {/* <div className={_s.answerBlock}>
        <SelectTemplate name="templateId" onChange={setTemplateId} value={templateId} />
        {templateId && (
          <AnswerForSpecifications
            name="specifications"
            onChange={setSpecifications}
            value={specifications}
            templateId={templateId}
            prefix="plan"
          />
        )}
      </div> */}
      <Button
        className={_s.answerBlock}
        type="primary"
        loading={isSubmitting}
        onClick={() => savePlan()}
      >
        Save
      </Button>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    user: state.auth.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

PlanEdit.propTypes = {
  user: PropTypes.object.isRequired
};

const connectedEdit = connect(mapStateToProps, mapDispatchToProps)(PlanEdit);

export default connectedEdit;
